module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.292afba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/time-attendance/fullscreen-image_hero_768.png
// module id = k97W
// module chunks = 0